module.exports = __webpack_public_path__ + "img/newsdetails5.a7b9ff9b.png";